var map = {
	"./courier-abffreight.svg": "8725",
	"./courier-aduiepyle.svg": "622c",
	"./courier-canadapost.svg": "1472",
	"./courier-canpar.svg": "2a19",
	"./courier-centraltransport.svg": "c616",
	"./courier-dayross.svg": "c042",
	"./courier-default.svg": "6310",
	"./courier-dhl.svg": "6e20",
	"./courier-estesexpress.svg": "9a54",
	"./courier-fastfrate.svg": "954e",
	"./courier-fedex.svg": "5e5c",
	"./courier-forwardair.svg": "b4c1",
	"./courier-gls.svg": "c773",
	"./courier-ics.svg": "e2dc",
	"./courier-jpexpress.svg": "8523",
	"./courier-loomis.svg": "6688",
	"./courier-maritimeontario.svg": "9040",
	"./courier-olddominion.svg": "6a0a",
	"./courier-ptc.svg": "6736",
	"./courier-purolator.svg": "2978",
	"./courier-purolatorfreight.svg": "d606",
	"./courier-rlcarriers.svg": "d920",
	"./courier-saia.svg": "443d",
	"./courier-tforcefreight.svg": "c782",
	"./courier-totalship.svg": "8cd5",
	"./courier-trexity.svg": "01ba",
	"./courier-truxweb.svg": "d288",
	"./courier-tsl.svg": "0ae7",
	"./courier-ups.svg": "27da",
	"./courier-usps.svg": "503b",
	"./courier-wardtrucking.svg": "10e5",
	"./courier-warp.svg": "4c59",
	"./courier-xpologistics.svg": "2257"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9f8a";